const VimeoModal = require('./lum-vimeo-modal.js');

(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-vimeo-modal:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return null;
        }

        const $module = $(`.fl-node-${data.node}`);
        $module.attr('data-label', data.name + ': ' + data.settings.editor_label);
        const module = new VimeoModal($module, data);
    }
})(jQuery);